import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ehd-page" }
const _hoisted_2 = {
  key: 0,
  class: "ehd-notice-overlay",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "ehd-notice-modal-title"
}
const _hoisted_3 = { class: "ehd-notice-modal" }
const _hoisted_4 = {
  class: "ehd-notice-modal-title",
  id: "ehd-notice-modal-title"
}
const _hoisted_5 = {
  key: 0,
  class: "ehd-notice-modal-amount"
}
const _hoisted_6 = { class: "ehd-notice-modal-amount-label" }
const _hoisted_7 = { class: "ehd-notice-modal-amount-value" }
const _hoisted_8 = {
  key: 1,
  class: "ehd-notice-modal-list"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "ehd-card ehd-invoice" }
const _hoisted_11 = { class: "ehd-invoice-top" }
const _hoisted_12 = { class: "ehd-invoice-title-block" }
const _hoisted_13 = { class: "ehd-invoice-title" }
const _hoisted_14 = { class: "ehd-invoice-id" }
const _hoisted_15 = { class: "ehd-invoice-id-value" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_18 = {
  key: 1,
  width: "13",
  height: "13",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_19 = { class: "ehd-invoice-mini-timer" }
const _hoisted_20 = { class: "ehd-invoice-mini-timer-label" }
const _hoisted_21 = { class: "ehd-invoice-payment-panel" }
const _hoisted_22 = { class: "ehd-invoice-brand" }
const _hoisted_23 = { class: "ehd-invoice-brand-text" }
const _hoisted_24 = { class: "ehd-invoice-brand-tagline" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "ehd-invoice-deeplink-hint" }
const _hoisted_27 = { class: "ehd-hint-desktop" }
const _hoisted_28 = { class: "ehd-hint-mobile" }
const _hoisted_29 = {
  class: "ehd-payer-notice",
  role: "note"
}
const _hoisted_30 = { class: "ehd-payer-notice-head" }
const _hoisted_31 = { class: "ehd-payer-notice-title" }
const _hoisted_32 = {
  key: 0,
  class: "ehd-payer-notice-amount"
}
const _hoisted_33 = { class: "ehd-payer-notice-amount-label" }
const _hoisted_34 = { class: "ehd-payer-notice-amount-value" }
const _hoisted_35 = { class: "ehd-payer-notice-text" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "ehd-btn-deeplink-cta-text" }
const _hoisted_38 = { class: "ehd-invoice-payment-warning" }
const _hoisted_39 = { class: "ehd-invoice-requisites" }
const _hoisted_40 = { class: "ehd-invoice-col-title" }
const _hoisted_41 = { class: "ehd-requisite-label" }
const _hoisted_42 = { class: "ehd-requisite-value" }
const _hoisted_43 = ["aria-label", "onClick"]
const _hoisted_44 = {
  key: 0,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_45 = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_46 = {
  class: "ehd-invoice-instruction",
  style: {"--ehd-instruction-bullet-bg":"#ef3124","--ehd-instruction-bullet-fg":"#ffffff"}
}
const _hoisted_47 = { class: "ehd-invoice-col-title" }
const _hoisted_48 = { class: "ehd-instructions" }
const _hoisted_49 = { class: "ehd-invoice-actions" }
const _hoisted_50 = ["disabled"]

import "@/assets/css/alfa-cross-border.css"
import {computed, onMounted, onUnmounted, ref, watch} from "vue";
import {useI18n} from "vue-i18n";
import QRCode from "qrcode-svg";
import DealDTO from "@/models/DealDTO";
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import {copy} from "@/service/helper";
import {numberFormatter} from "@/service/NumberFormatter";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlfaCrossBorderPage',
  props: {
    confirmTransfer: { type: Function },
    cancelDeal: { type: Function },
    currentDeal: {},
    invoice: {}
  },
  setup(__props: any) {

const props = __props

const {t, te} = useI18n({useScope: 'global'})

const now = ref(Date.now())
const copiedKey = ref('')
const instructionExpanded = ref(false)
const confirmPending = ref(false)
const noticeSecondsLeft = ref(5)
let timer: number | null = null
let noticeTimer: number | null = null

const isDefaultAlfaNotice = (lines: string[]): boolean => {
  return lines.length === 4
    && lines[0] === 'Выберите перевод за границу/международный перевод'
    && lines[1] === 'Скопируйте номер телефона с кодом страны'
    && lines[2].startsWith('Вставьте номер ')
    && lines[3].startsWith('Введите точную сумму ')
}

const rawInstructionLines = computed(() => {
  const instructions = props.invoice.flowData?.instructions
  if (Array.isArray(instructions)) {
    return instructions.filter((line: unknown): line is string => typeof line === 'string' && line.trim() !== '')
  }
  if (typeof instructions === 'string' && instructions.trim() !== '') {
    return [instructions]
  }
  return []
})

const noticeLines = computed(() => {
  const lines = rawInstructionLines.value
  if (lines.length > 0 && isDefaultAlfaNotice(lines) === false) {
    return lines
  }

  return [
    t('alfa-cross-border.notice.line-1'),
    t('alfa-cross-border.notice.line-2'),
    t('alfa-cross-border.notice.line-3'),
  ]
})

const displayedSum = computed(() => {
  const local = props.invoice.flowData?.receiveSum
  if (
    local
    && typeof local.amount !== 'undefined'
    && local.amount !== null
    && local.amount !== ''
    && typeof local.currency === 'string'
    && local.currency !== ''
  ) {
    return {amount: String(local.amount), currency: local.currency}
  }

  return {
    amount: String(props.invoice.sum.amount),
    currency: props.invoice.sum.currency,
  }
})

const receiveAmountText = computed(() => {
  const amount = Number(displayedSum.value.amount)
  const currency = displayedSum.value.currency
  if (Number.isFinite(amount) === false || typeof currency !== 'string' || currency === '') {
    return ''
  }

  return numberFormatter.formatMoney(amount, currency) ?? ''
})

const noticeDismissed = ref(false)

const previousBodyOverflow = document.body.style.overflow

watch(noticeDismissed, (dismissed) => {
  document.body.style.overflow = dismissed ? previousBodyOverflow : 'hidden'
}, {immediate: true})

onMounted(() => {
  timer = window.setInterval(() => {
    now.value = Date.now()
  }, 1000)
  noticeTimer = window.setInterval(() => {
    if (noticeSecondsLeft.value <= 0 && noticeTimer !== null) {
      clearInterval(noticeTimer)
      noticeTimer = null
      return
    }
    noticeSecondsLeft.value -= 1
  }, 1000)
})

onUnmounted(() => {
  document.body.style.overflow = previousBodyOverflow
  if (timer !== null) {
    clearInterval(timer)
  }
  if (noticeTimer !== null) {
    clearInterval(noticeTimer)
  }
})

const invoiceId = computed(() => props.invoice.internalId || props.invoice.id)

const deadline = computed(() => new Date(props.currentDeal.canceledAt).getTime())

const secondsLeft = computed(() => Math.max(0, Math.floor((deadline.value - now.value) / 1000)))

const timeLeft = computed(() => {
  const minutes = Math.floor(secondsLeft.value / 60)
  return `${String(minutes).padStart(2, '0')}:${String(secondsLeft.value % 60).padStart(2, '0')}`
})

const timerUrgent = computed(() => secondsLeft.value < 120)
const timerExpired = computed(() => secondsLeft.value <= 0)

const countryName = computed(() => {
  const currency = props.invoice.crossBorderCurrency
  return currency && te(`countries.${currency}`) ? t(`countries.${currency}`) : ''
})

const holder = computed(() => String(props.currentDeal.requisites?.holder ?? '').trim())
const rawRequisites = computed(() => String(props.currentDeal.requisites?.requisites ?? '').trim())
const isPhone = computed(() => rawRequisites.value.replace(/\D/g, '').length < 16)
const countryLabel = computed(() => countryName.value || t('alfa-cross-border.country-fallback'))

const recipientBank = computed(() => {
  const method = props.currentDeal.paymentMethod
  if (method && te(`methods.${method}`)) {
    return t(`methods.${method}`)
  }
  return method ?? ''
})

const deeplink = computed(() => {
  const links = props.invoice.flowData?.deeplinks
  if (Array.isArray(links) === false || links.length === 0) {
    return ''
  }
  return typeof links[0] === 'string' ? links[0] : ''
})

const qrSvg = computed(() => new QRCode({
  content: window.location.href,
  join: true,
  container: 'svg-viewbox',
  padding: 0,
  color: '#1a1a1a',
  background: '#FFFFFF',
}).svg())

const requisiteRows = computed(() => {
  const rows = [
    {key: 'amount', label: t('alfa-cross-border.field-amount'), value: receiveAmountText.value, copy: receiveAmountText.value},
    {key: 'country', label: t('alfa-cross-border.field-country'), value: countryName.value, copy: countryName.value},
    {key: 'bank', label: t('alfa-cross-border.field-bank'), value: recipientBank.value, copy: recipientBank.value},
    {key: 'owner', label: t('alfa-cross-border.field-owner'), value: holder.value, copy: holder.value},
  ]
  if (isPhone.value) {
    rows.push({
      key: 'phone',
      label: t('alfa-cross-border.field-phone'),
      value: rawRequisites.value,
      copy: rawRequisites.value.replace(/[^\d+]/g, ''),
    })
  } else if (rawRequisites.value !== '') {
    rows.push({
      key: 'card',
      label: t('alfa-cross-border.field-card'),
      value: rawRequisites.value,
      copy: rawRequisites.value.replace(/\s/g, ''),
    })
  }
  return rows.filter((row) => row.value !== '')
})

const instructionSteps = computed(() => [
  t('alfa-cross-border.instruction.step-1'),
  t('alfa-cross-border.instruction.step-2'),
  t('alfa-cross-border.instruction.step-3'),
  t('alfa-cross-border.instruction.step-4', {country: countryLabel.value}),
  t('alfa-cross-border.instruction.step-5'),
  t('alfa-cross-border.instruction.step-6', {phone: rawRequisites.value}),
  t('alfa-cross-border.instruction.step-7', {bank: recipientBank.value}),
  t('alfa-cross-border.instruction.step-8'),
  t('alfa-cross-border.instruction.step-9', {amount: receiveAmountText.value}),
  t('alfa-cross-border.instruction.step-10'),
])

const copyField = (key: string, value: string) => {
  copy(null, value)
  copiedKey.value = key
  window.setTimeout(() => {
    if (copiedKey.value === key) {
      copiedKey.value = ''
    }
  }, 1000)
}

const onConfirm = () => {
  confirmPending.value = true
  props.confirmTransfer()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (noticeDismissed.value === false)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('alfa-cross-border.notice-title')), 1),
            (receiveAmountText.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('alfa-cross-border.notice-min-label')), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(receiveAmountText.value), 1)
                ]))
              : _createCommentVNode("", true),
            (noticeLines.value.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeLines.value, (line, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(line), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "ehd-notice-modal-btn",
              disabled: noticeSecondsLeft.value > 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (noticeDismissed.value = true))
            }, _toDisplayString(noticeSecondsLeft.value > 0
            ? _ctx.$t('alfa-cross-border.notice-wait', {seconds: noticeSecondsLeft.value})
            : _ctx.$t('alfa-cross-border.notice-ok')), 9, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("article", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.$t('alfa-cross-border.title')), 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, "ID: " + _toDisplayString(invoiceId.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["ehd-invoice-id-copy", {copied: copiedKey.value === 'id'}]),
              "aria-label": _ctx.$t('alfa-cross-border.copy-id'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyField('id', invoiceId.value)))
            }, [
              (copiedKey.value === 'id')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[5] || (_cache[5] = [
                    _createElementVNode("path", {
                      d: "M5 12.5L10 17.5L19 7.5",
                      stroke: "currentColor",
                      "stroke-width": "2.4",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ])))
                : (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[6] || (_cache[6] = [
                    _createElementVNode("rect", {
                      x: "8",
                      y: "8",
                      width: "12",
                      height: "12",
                      rx: "2.5",
                      stroke: "currentColor",
                      "stroke-width": "1.8"
                    }, null, -1),
                    _createElementVNode("path", {
                      d: "M16 8V6.5C16 5.11929 14.8807 4 13.5 4H6.5C5.11929 4 4 5.11929 4 6.5V13.5C4 14.8807 5.11929 16 6.5 16H8",
                      stroke: "currentColor",
                      "stroke-width": "1.8"
                    }, null, -1)
                  ])))
            ], 10, _hoisted_16)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('alfa-cross-border.waiting')), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["ehd-invoice-mini-timer-value", {urgent: timerUrgent.value}])
          }, _toDisplayString(timeLeft.value), 3)
        ])
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "ehd-invoice-section-divider" }, null, -1)),
      _createElementVNode("section", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "ehd-invoice-brand-mark" }, [
            _createElementVNode("img", {
              src: "/banks/alfa.svg",
              alt: "",
              height: "56"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('alfa-cross-border.brand')), 1)
          ]),
          _createElementVNode("div", {
            class: "ehd-invoice-qr",
            innerHTML: qrSvg.value
          }, null, 8, _hoisted_25)
        ]),
        _createElementVNode("p", _hoisted_26, [
          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('alfa-cross-border.qr-hint-desktop')), 1),
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('alfa-cross-border.qr-hint-mobile')), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "ehd-invoice-warning-icon" }, "!", -1)),
            _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('alfa-cross-border.notice-check-title')), 1)
          ]),
          (receiveAmountText.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('alfa-cross-border.notice-receive-label')), 1),
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('alfa-cross-border.notice-receive-value', {amount: receiveAmountText.value})), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('alfa-cross-border.notice-short')), 1)
        ]),
        (deeplink.value)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: deeplink.value,
              class: "ehd-btn-deeplink-cta",
              rel: "noopener",
              style: {"background":"#ef3124","color":"#ffffff","border-color":"#ef3124"}
            }, [
              _createElementVNode("span", _hoisted_37, [
                _createTextVNode(_toDisplayString(_ctx.$t('alfa-cross-border.pay-with')) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t('alfa-cross-border.bank')), 1)
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ehd-cta-bank-logo" }, [
                _createElementVNode("img", {
                  src: "/banks/alf_white.png",
                  alt: "",
                  height: "28"
                })
              ], -1))
            ], 8, _hoisted_36))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ehd-invoice-warning-icon" }, "!", -1)),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('alfa-cross-border.only-alfa-before')) + " ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('alfa-cross-border.bank')), 1),
            _createTextVNode(". " + _toDisplayString(_ctx.$t('alfa-cross-border.only-alfa-after')), 1)
          ])
        ])
      ]),
      _cache[16] || (_cache[16] = _createElementVNode("hr", { class: "ehd-invoice-section-divider" }, null, -1)),
      _createElementVNode("section", _hoisted_39, [
        _createElementVNode("h2", _hoisted_40, _toDisplayString(_ctx.$t('alfa-cross-border.requisites')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requisiteRows.value, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            key: row.key,
            class: "ehd-requisite-row"
          }, [
            _createElementVNode("div", _hoisted_41, _toDisplayString(row.label), 1),
            _createElementVNode("div", _hoisted_42, _toDisplayString(row.value), 1),
            (row.copy)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: _normalizeClass(["ehd-copy-btn-icon", {copied: copiedKey.value === row.key}]),
                  "aria-label": _ctx.$t('alfa-cross-border.copy'),
                  onClick: ($event: any) => (copyField(row.key, row.copy))
                }, [
                  (copiedKey.value === row.key)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[11] || (_cache[11] = [
                        _createElementVNode("path", {
                          d: "M5 12.5L10 17.5L19 7.5",
                          stroke: "currentColor",
                          "stroke-width": "2.4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_45, _cache[12] || (_cache[12] = [
                        _createElementVNode("rect", {
                          x: "8",
                          y: "8",
                          width: "12",
                          height: "12",
                          rx: "2.5",
                          stroke: "currentColor",
                          "stroke-width": "1.8"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M16 8V6.5C16 5.11929 14.8807 4 13.5 4H6.5C5.11929 4 4 5.11929 4 6.5V13.5C4 14.8807 5.11929 16 6.5 16H8",
                          stroke: "currentColor",
                          "stroke-width": "1.8"
                        }, null, -1)
                      ])))
                ], 10, _hoisted_43))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "ehd-invoice-section-divider" }, null, -1)),
      _createElementVNode("section", _hoisted_46, [
        _createElementVNode("h2", _hoisted_47, _toDisplayString(_ctx.$t('alfa-cross-border.instruction-title')), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["ehd-instruction-body", {'ehd-instruction-body-clipped': isPhone.value && instructionExpanded.value === false}])
        }, [
          _createElementVNode("ol", _hoisted_48, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instructionSteps.value, (step) => {
              return (_openBlock(), _createElementBlock("li", { key: step }, _toDisplayString(step), 1))
            }), 128))
          ])
        ], 2),
        (isPhone.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ehd-instruction-toggle",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (instructionExpanded.value = !instructionExpanded.value))
            }, [
              _createElementVNode("span", null, _toDisplayString(instructionExpanded.value ? _ctx.$t('alfa-cross-border.collapse') : _ctx.$t('alfa-cross-border.expand')), 1),
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["ehd-instruction-toggle-chevron", {expanded: instructionExpanded.value}]),
                width: "14",
                height: "14",
                viewBox: "0 0 16 16",
                fill: "none",
                "aria-hidden": "true"
              }, _cache[13] || (_cache[13] = [
                _createElementVNode("path", {
                  d: "M4 6 L8 10 L12 6",
                  stroke: "currentColor",
                  "stroke-width": "1.6",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }, null, -1)
              ]), 2))
            ]))
          : _createCommentVNode("", true)
      ]),
      _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "ehd-invoice-section-divider" }, null, -1)),
      _createElementVNode("div", _hoisted_49, [
        _createElementVNode("button", {
          type: "button",
          class: "ehd-btn-primary",
          disabled: confirmPending.value || timerExpired.value,
          onClick: onConfirm
        }, [
          _createElementVNode("span", null, _toDisplayString(confirmPending.value ? _ctx.$t('alfa-cross-border.confirming') : _ctx.$t('alfa-cross-border.confirm')), 1),
          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ehd-cta-bank-logo" }, [
            _createElementVNode("img", {
              src: "/banks/alf_white.png",
              alt: "",
              height: "24"
            })
          ], -1))
        ], 8, _hoisted_50),
        (_ctx.invoice.cancelUrl)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ehd-btn-ghost",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelDeal(_ctx.invoice.cancelUrl)))
            }, _toDisplayString(_ctx.$t('alfa-cross-border.back-to-shop')), 1))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "ehd-btn-ghost",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelDeal(null)))
            }, _toDisplayString(_ctx.$t('alfa-cross-border.cancel')), 1))
      ])
    ])
  ]))
}
}

})